import { createContext, useContext, useEffect } from "react";
import PropTypes from "prop-types";

export const StatusContext = createContext(null);

export default function Status({ code, redirectURL, children }) {
	const ctx = useContext(StatusContext);
	useEffect(() => {
		if (ctx) {
			ctx.status = code;
			if (redirectURL) ctx.redirectURL = redirectURL;
		}
	}, [ctx, code, redirectURL]);

	// SSR: set synchronously so renderToString captures it
	if (ctx) {
		ctx.status = code;
		if (redirectURL) ctx.redirectURL = redirectURL;
	}

	return children;
}

Status.propTypes = {
	code: PropTypes.number.isRequired,
	redirectURL: PropTypes.string,
	children: PropTypes.node
};